<template>
  <div class="amprod-cart-item">
    <div class="cart-item-header">
      <div class="product-info">
        <div class="product-title-row">
          <h3 class="product-name">
            {{
              item.isStandalone && item.type === "option" && item.options?.[0]
                ? item.options[0].description ||
                  item.options[0].part_number ||
                  "Unknown Option"
                : item.product?.name ||
                  item.product?.part_number ||
                  "Unknown Product"
            }}
          </h3>
          <span class="quantity-badge">x{{
            item.isStandalone && item.type === "option" && item.options?.[0]
              ? item.options[0].quantity || 1
              : item.quantity || 1
          }}</span>
        </div>
        <div
          v-if="
            item.isStandalone &&
              item.type === 'option' &&
              item.options?.[0]?.part_number
          "
          class="product-part-number"
        >
          Part Number: {{ item.options[0].part_number }}
        </div>
        <div
          v-else-if="!item.isStandalone && item.product?.part_number"
          class="product-part-number"
        >
          Part Number: {{ item.product.part_number }}
        </div>
      </div>
    </div>

    <div class="cart-item-subheader">
      <div class="subheader-actions">
        <button
          v-if="item.configUrl && !item.isStandalone"
          class="edit-item-btn"
          :title="'Edit ' + (item.product?.name || 'item')"
          @click="editItem"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            />
            <path
              d="m18.5 2.5 a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
            />
          </svg>
          Edit
        </button>
        <button
          class="remove-item-btn"
          :title="'Remove ' + (item.product?.name || 'item')"
          @click="$emit('remove-item')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polyline points="3,6 5,6 21,6" />
            <path
              d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,2h4a2,2 0 0,1 2,2v2"
            />
          </svg>
          Remove
        </button>
      </div>
    </div>

    <div
      v-if="!item.isStandalone && item.options && item.options.length > 0"
      class="cart-item-content"
    >
      <div class="configuration-details">
        <h4>Selected Options:</h4>
        <ul class="configuration-list">
          <li
            v-for="option in item.options"
            :key="option.id"
            class="configuration-item"
          >
            <div class="config-option">
              <div class="option-details">
                <span class="option-part-number">{{ option.part_number }}</span>
                <span
                  v-if="option.description"
                  class="option-description"
                >
                  - {{ option.description }}
                </span>
              </div>
              <QuantityDisplay
                :quantity="option.quantity || 1"
                label=""
                variant="badge"
                class="option-quantity-display"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import QuantityDisplay from "../common/QuantityDisplay.vue";

export default {
  name: "CartItem",
  components: {
    QuantityDisplay,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["remove-item", "edit-item"],
  methods: {
    editItem() {
      this.$emit("edit-item", this.item);
    },
  },
};
</script>

<style scoped>
.amprod-cart-item {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.amprod-cart-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.cart-item-header {
  background-color: #f8f9fa;
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.product-info {
  flex: 1;
}

.product-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 5px;
}

.product-name {
  margin: 0;
  color: #0073aa;
  font-size: 18px;
}

.quantity-badge {
  background-color: #0073aa;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.product-part-number {
  font-weight: 600;
  color: #555;
  font-size: 14px;
  margin: 0;
}

.cart-item-subheader {
  background-color: #f8f9fa;
  padding: 12px 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.subheader-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.edit-item-btn,
.remove-item-btn {
  background: none;
  border: 1px solid transparent;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.edit-item-btn {
  color: #0073aa;
  border-color: #0073aa;
}

.edit-item-btn:hover {
  background-color: #0073aa;
  color: white;
}

.remove-item-btn {
  color: #dc3545;
  border-color: #dc3545;
}

.remove-item-btn:hover {
  background-color: #dc3545;
  color: white;
}

.cart-item-content {
  padding: 20px;
}

.configuration-details h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 14px;
}

.configuration-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.configuration-item {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.configuration-item:last-child {
  border-bottom: none;
}

.config-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.option-details {
  flex: 1;
  font-size: 13px;
}

.option-part-number {
  font-weight: 600;
  color: #0073aa;
}

.option-description {
  color: #555;
}

/* Responsive design */
@media (max-width: 768px) {
  .product-title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .cart-item-subheader {
    justify-content: center;
  }

  .subheader-actions {
    justify-content: center;
  }

  .edit-item-btn,
  .remove-item-btn {
    flex: 1;
    justify-content: center;
  }
}
</style>
